import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import _typeof from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import parse from 'url-parse';
import queryString from '../utils/queryString';

function makeUrl(url, data) {
  var searchStr = queryString(data);
  var urlHasSeach = url.indexOf('?') >= 0;
  return urlHasSeach ? "".concat(url, "&").concat(searchStr) : "".concat(url, "?").concat(searchStr);
}

var Request = /*#__PURE__*/function () {
  /**
   * 构造请求对象
   * @param {string} url
   * @param {object|undefined} data
   * @param {object|undefined} options
   */
  function Request(url, data, options) {
    _classCallCheck(this, Request);

    if (typeof url === 'undefined') throw new TypeError('url 不能为空');

    if (_typeof(url) === 'object') {
      data = url;
      url = data.url;
      delete data.url;
      if (!url) throw new TypeError('没有找到url属性');
    } // 支持通过 data 给 url 传递参数


    url = url.replace(/\$\{([^}]*)\}/g, function (item, name) {
      if (data[name]) {
        var val = data[name];
        delete data[name];
        return val;
      } else {
        return item;
      }
    });
    this._url = parse(url, true);
    this.data = data;
    this.options = options || {};
    this.reqUrl = makeUrl(url, data);
  }

  _createClass(Request, [{
    key: "url",
    get: function get() {
      return this._url.toString();
    },
    set: function set(url) {
      this._url = parse(url, true);
    }
  }, {
    key: "protocol",
    get: function get() {
      return this._url.protocol;
    },
    set: function set(val) {
      this._url.set('protocol', val);
    }
  }, {
    key: "hostname",
    get: function get() {
      return this._url.hostname;
    },
    set: function set(val) {
      this._url.set('hostname', val);
    }
  }, {
    key: "port",
    get: function get() {
      return this._url.port;
    },
    set: function set(val) {
      this._url.set('port', val);
    }
  }, {
    key: "pathname",
    get: function get() {
      return this._url.pathname;
    },
    set: function set(val) {
      this._url.set('pathname', val);
    }
  }, {
    key: "query",
    get: function get() {
      return this._url.query;
    },
    set: function set(val) {
      this._url.set('query', val);
    }
  }]);

  return Request;
}();

export { Request as default };